!function (t, e) {
  if ("object" == typeof exports && "object" == typeof module) module.exports = e(require("validatorjs"));else if ("function" == typeof define && define.amd) define(["validatorjs"], e);else {
    var n = "object" == typeof exports ? e(require("validatorjs")) : e(t.validatorjs);

    for (var r in n) {
      ("object" == typeof exports ? exports : t)[r] = n[r];
    }
  }
}(window, function (n) {
  return i = {}, o.m = r = [function (t, e, n) {
    "use strict";

    var _r,
        o = this && this.__extends || (_r = function r(t, e) {
      return (_r = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (t, e) {
        t.__proto__ = e;
      } || function (t, e) {
        for (var n in e) {
          e.hasOwnProperty(n) && (t[n] = e[n]);
        }
      })(t, e);
    }, function (t, e) {
      function n() {
        this.constructor = t;
      }

      _r(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
    }),
        i = this && this.__spreadArrays || function () {
      for (var t = 0, e = 0, n = arguments.length; e < n; e++) {
        t += arguments[e].length;
      }

      for (var r = Array(t), o = 0, e = 0; e < n; e++) {
        for (var i = arguments[e], s = 0, a = i.length; s < a; s++, o++) {
          r[o] = i[s];
        }
      }

      return r;
    };

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.Lang = void 0;
    var c = n(1),
        s = n(2);
    Object.defineProperty(e, "Lang", {
      enumerable: !0,
      get: function get() {
        return s.Lang;
      }
    });
    var a,
        u = (a = s.ReactFormInputValidation, o(f, a), f.useLang = function (t) {
      c.useLang(t);
    }, f.register = function (t, e, n) {
      c.register(t, e, n);
    }, f.registerAsync = function (t, e) {
      c.registerAsync(t, e);
    }, f.setMessages = function (t, e) {
      c.setMessages(t, e);
    }, f.getMessages = function (t) {
      return c.getMessages(t);
    }, f.getDefaultLang = function () {
      return c.getDefaultLang();
    }, f.setAttributeFormatter = function (t) {
      c.setAttributeFormatter(t);
    }, Object.defineProperty(f.prototype, "onformsubmit", {
      get: function get() {
        return this._onformsubmit;
      },
      set: function set(t) {
        this._onformsubmit && a.prototype.removeListener.call(this, "formsubmit", this._onformsubmit), this._onformsubmit = t, a.prototype.addListener.call(this, "formsubmit", this._onformsubmit);
      },
      enumerable: !1,
      configurable: !0
    }), f.prototype.addEventListener = function (t, e) {
      return a.prototype.addListener.call(this, t, e), this;
    }, f.prototype.removeEventListener = function (t, e) {
      return a.prototype.removeListener.call(this, t, e), this;
    }, f.prototype.useRules = function (t) {
      this.rules = t;
    }, f.prototype.handleChangeEvent = function (t) {
      var e,
          n = t.target.name;
      this.component && n && ((e = Object.assign({}, this.component.state.fields))[n] = "checkbox" === t.target.type ? this.getCheckboxValues(t.target) : "radio" === t.target.type ? this.getRadioButtonValues(t.target) : t.target.value, this.component.setState({
        fields: e,
        isValidatorUpdate: !0
      }));
    }, f.prototype.handleBlurEvent = function (t) {
      var e = this,
          n = t.target;
      this.validate([n]).then(function (t) {
        e.component && e.component.hasOwnProperty("state") && (e.errors = Object.assign(e.errors, t), e.component.setState({
          errors: e.errors,
          isValidatorUpdate: !0
        }));
      }).catch(function (t) {
        return console.error(t);
      });
    }, f.prototype.handleSubmit = function (t) {
      var e = this;
      t.preventDefault(), this.validateForm(t.target).then(function (t) {
        t && a.prototype.emit.call(e, e.getEvent(e.component.state.fields));
      });
    }, f.prototype.validateForm = function (n) {
      var r = this;
      this.component && this.component.state || (this.component.state = {
        errors: {}
      });
      var o = [];
      return n.querySelectorAll("textarea,select,input:not([type='submit']):not([type='file']):not([data-ignore-validation])").forEach(function (t) {
        o.push(t);
      }), new Promise(function (e) {
        r.validate(o).then(function (t) {
          r.errors = t, r.component.setState({
            errors: r.errors,
            isValidatorUpdate: !0
          }), Object.keys(r.component.state.errors)[0] && n.querySelector('[name="' + Object.keys(r.component.state.errors)[0] + '"]') && n.querySelector('[name="' + Object.keys(r.component.state.errors)[0] + '"]').focus(), e(0 === Object.keys(r.component.state.errors).length);
        }).catch(function (t) {
          return console.log(t);
        });
      });
    }, f.prototype.getRadioButtonValues = function (t) {
      var e = document.getElementsByName(t.name),
          n = i(e).filter(function (t) {
        return !0 === t.checked;
      });
      return n[0] ? n[0].value : "";
    }, f.prototype.getCheckboxValues = function (t) {
      var e = document.getElementsByName(t.name),
          n = i(e).filter(function (t) {
        return !0 === t.checked;
      }),
          r = [];
      return n.forEach(function (t) {
        return r.push(t.value);
      }), r;
    }, f.prototype.validate = function (a) {
      var u = this;
      return new Promise(function (t) {
        var e = {},
            r = {},
            o = {},
            i = {},
            s = !1;
        a.forEach(function (t) {
          var e,
              n = t.getAttribute("name");
          r[n] = u.component.state.fields[n], o[n] = u.rules[n], o[n] || (console.warn("Rule is not defind for " + n), o[n] = ""), n.endsWith("_confirmation") && (e = n.slice(0, n.indexOf("_confirmation")), r[e] = u.component.state.fields[e]), t.hasAttribute("data-attribute-name") && (i[n] = t.getAttribute("data-attribute-name")), t.hasAttribute("data-async") && (s = !0);
        });
        var n = new c(r, o);
        if (n.setAttributeNames(i), !s) return n.fails() ? e = u.fillErrors(n) : u.invalidateErrors(r), t(e);
        n.checkAsync(function () {
          u.invalidateErrors(r), t(e);
        }, function () {
          e = u.fillErrors(n), t(e);
        });
      });
    }, f.prototype.fillErrors = function (e) {
      var n = {};
      return Object.keys(e.errors.all()).forEach(function (t) {
        n[t] = e.errors.first(t);
      }), n;
    }, f.prototype.invalidateErrors = function (t) {
      var e = this;
      Object.keys(t).forEach(function (t) {
        delete e.errors[t];
      });
    }, f.prototype.getEvent = function (t) {
      return new CustomEvent("formsubmit", {
        detail: t
      });
    }, f);

    function f(t, e) {
      var n = a.call(this, t, e) || this;
      return n.rules = {}, n.errors = {}, f.useLang(e && e.locale ? e.locale : "en"), n.component = t, n.handleChangeEvent = n.handleChangeEvent.bind(n), n.handleSubmit = n.handleSubmit.bind(n), n.handleBlurEvent = n.handleBlurEvent.bind(n), n;
    }

    e.default = u;
  }, function (t, e) {
    t.exports = n;
  }, function (t, e, n) {
    "use strict";

    var _r2,
        o,
        i = this && this.__extends || (_r2 = function r(t, e) {
      return (_r2 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (t, e) {
        t.__proto__ = e;
      } || function (t, e) {
        for (var n in e) {
          e.hasOwnProperty(n) && (t[n] = e[n]);
        }
      })(t, e);
    }, function (t, e) {
      function n() {
        this.constructor = t;
      }

      _r2(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
    });

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.ReactFormInputValidation = e.Lang = void 0, (o = e.Lang || (e.Lang = {})).ar = "ar", o.az = "az", o.be = "be", o.bg = "bg", o.bs = "bs", o.ca = "ca", o.cs = "cs", o.cy = "cy", o.da = "da", o.de = "de", o.el = "el", o.en = "en", o.es = "es", o.et = "et", o.eu = "eu", o.fa = "fa", o.fi = "fi", o.fr = "fr", o.hr = "hr", o.hu = "hu", o.id = "id", o.it = "it", o.ja = "ja", o.ka = "ka", o.ko = "ko", o.It = "It", o.Iv = "Iv", o.mk = "mk", o.mn = "mn", o.ms = "ms", o.nb_NO = "nb_NO", o.nl = "nl", o.pl = "pl", o.pt = "pt", o.pt_BR = "pt_BR", o.ro = "ro", o.ru = "ru", o.se = "se", o.sl = "sl", o.sq = "sq", o.sr = "sr", o.sv = "sv", o.tr = "tr", o.ua = "ua", o.uk = "uk", o.vi = "vi", o.zh = "zh", o.zh_TW = "zh_TW";
    var s,
        a = (u.prototype.addListener = function (t, e) {
      t in this.listeners || (this.listeners[t] = []), this.listeners[t].push(e);
    }, u.prototype.removeListener = function (t, e) {
      if (t in this.listeners) for (var n = this.listeners[t], r = 0, o = n.length; r < o; r++) {
        if (n[r] === e) return void n.splice(r, 1);
      }
    }, u.prototype.emit = function (t) {
      if (!(t.type in this.listeners)) return !0;

      for (var e = this.listeners[t.type].slice(), n = 0, r = e.length; n < r; n++) {
        e[n].call(this, t.detail);
      }

      return !t.defaultPrevented;
    }, u);

    function u() {
      this.listeners = {};
    }

    var c,
        f = (i(l, c = a), l.useLang = function (t) {}, l.register = function (t, e, n) {}, l.registerAsync = function (t, e) {}, l.setMessages = function (t, e) {}, l.getMessages = function (t) {
      return s;
    }, l.getDefaultLang = function () {
      return s;
    }, l.setAttributeFormatter = function (t) {}, l.prototype.addEventListener = function (t, e) {
      return s;
    }, l.prototype.removeEventListener = function (t, e) {
      return s;
    }, l.prototype.useRules = function (t) {}, l.prototype.handleChangeEvent = function (t) {}, l.prototype.handleBlurEvent = function (t) {}, l.prototype.handleSubmit = function (t) {}, l);

    function l(t, e) {
      return c.call(this) || this;
    }

    e.ReactFormInputValidation = f;
  }], o.c = i, o.d = function (t, e, n) {
    o.o(t, e) || Object.defineProperty(t, e, {
      enumerable: !0,
      get: n
    });
  }, o.r = function (t) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, o.t = function (e, t) {
    if (1 & t && (e = o(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var n = Object.create(null);
    if (o.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var r in e) {
      o.d(n, r, function (t) {
        return e[t];
      }.bind(null, r));
    }
    return n;
  }, o.n = function (t) {
    var e = t && t.__esModule ? function () {
      return t.default;
    } : function () {
      return t;
    };
    return o.d(e, "a", e), e;
  }, o.o = function (t, e) {
    return Object.prototype.hasOwnProperty.call(t, e);
  }, o.p = "", o(o.s = 0);

  function o(t) {
    if (i[t]) return i[t].exports;
    var e = i[t] = {
      i: t,
      l: !1,
      exports: {}
    };
    return r[t].call(e.exports, e, e.exports, o), e.l = !0, e.exports;
  }

  var r, i;
});